import { css } from '@emotion/react'

const row = css`
  & > *:nth-of-type(even) {
    width: 216px;
    flex-shrink: 0;
  }
  & > *:nth-of-type(odd) {
    flex: 1;
  }
`

const summary = theme => css`
  border-bottom: 1px solid ${theme.color.monochrome.medium};

  li:not(:last-of-type) {
    margin-bottom: 8px;
  }
  li > *:last-child {
    display: inline-block;
    width: 120px;
  }

  li button:disabled {
    opacity: 0.6;
    cursor: text;
  }
`

export const styles = { summary, row }
